
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/conferences/[eventId]",
      function () {
        return require("private-next-pages/events/conferences/[eventId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/conferences/[eventId]"])
      });
    }
  